// extracted by mini-css-extract-plugin
var _1 = "address";
export { _1 as "address" }
